import { z } from 'zod';

export const crmAttachmentInputSchema = z.object({
    attachmentId: z.string().optional(),
    externalUuid: z.uuid(),
    cdnUrl: z.url(),
    cdnUrlModifiers: z.string(),
    name: z.string().min(1),
    size: z.number().nonnegative(),
    mimeType: z.string().min(1),
    isImage: z.boolean(),
    s3Url: z.string().nullable(),
    s3Bucket: z.string().nullable(),
    previewCdnUrl: z.string().nullable().optional(),
});

export type CrmAttachmentInput = z.infer<typeof crmAttachmentInputSchema>;

export const crmAttachmentDtoSchema = crmAttachmentInputSchema.extend({
    attachmentId: z.string(),
});
